import StoreController from '@projeccions-pdc/frontend-storage';
import FileDeliveryService from './apiclients/FileDeliveryService';
import ContentService from './apiclients/ContentService';

class FavoritesController {
    constructor(platformId, userSub) {
        this._StoreController = new StoreController(platformId, userSub);
    }

    getFavorites = async (simplified) => {
        let data = [];
        try {
            data = await ContentService.getFavorites();
            data = data.favorites;

            if (simplified !== true) {
                for (let i = 0; i < data.length; i++) {
                    let fav = data[i];
                    //getcontent per el delivery
                    try {
                        let subresponse = await FileDeliveryService.getContent(
                            fav.contentId,
                            undefined,
                            { active: true, ttl: 30000 }
                        );
                        data[i] = subresponse;
                        //console.log('subresponse', subresponse);
                    } catch (err) {
                        console.log('err', err);
                        //data[i] = fav
                    }
                }
            }
            //console.log('getFavorites', data);
            this._StoreController.set('myFavorites', data);
        } catch (err) {
            console.log('error getting favorites -> fallback load from storage', err.message);
            data = this._StoreController.get('myFavorites');
            data = data ? data : [];
        }
        return data;
    }

    addFavorite = async (contentId) => {
        try {
            let response = await ContentService.addFavorite(
                contentId
            );
            return response;
        } catch (err) {
            console.log('error adding fav', err.message);
        }
    }

    removeFavorite = async (contentId) => {
        try {
            let response = await ContentService.removeFavorite(
                contentId
            );
            return response;
        } catch (err) {
            console.log('error removing fav', err.message);
        }
    }
}

export default FavoritesController;